import { SmartphotoField } from './fields/smartphoto-field.class';
import { Constants } from '../constants';
const defaultDocumentArray = [
    {
        id: 'policy',
        name: 'Policy',
        name_es: 'Póliza',
        type: 'policy',
        capture: 'camera',
        bgImage: '../../assets/images/logo/camera.svg',
        isBGShow: true,
        loading: false,
        auxId: 'aux_policy',
        mandatory: true
    },
    {
        id: 'license',
        name: 'Driver license',
        name_es: 'Licencia de conducir',
        type: 'license',
        capture: 'camera',
        bgImage: '../../assets/images/logo/camera.svg',
        isBGShow: true,
        loading: false,
        auxId: 'aux_license',
        mandatory: true
    },
    {
        id: 'plate',
        name: 'Plate',
        name_es: 'Placa',
        type: 'registration',
        capture: 'camera',
        bgImage: '../../assets/images/logo/camera.svg',
        isBGShow: true,
        loading: false,
        auxId: 'aux_plate',
        mandatory: true
    },
    {
        id: 'vin',
        name: 'VIN',
        name_es: 'VIN',
        type: 'vin',
        capture: 'camera',
        bgImage: '../../assets/images/logo/camera.svg',
        isBGShow: true,
        loading: false,
        auxId: 'aux_vin',
        mandatory: true
    }
];
const defaultDamagePictures = [
    {
        id: 'image1',
        name: 'Damage',
        name_es: 'Damage',
        type: 'damage_1',
        bgImage: '/assets/images/logo/camera_new.svg',
        isBGShow: true,
        loading: false
    },
    {
        id: 'image2',
        name: 'Damage',
        name_es: 'Damage',
        type: 'damage_2',
        bgImage: '/assets/images/logo/camera_new.svg',
        isBGShow: true,
        loading: false
    },
    {
        id: 'image3',
        name: 'Damage',
        name_es: 'Damage',
        type: 'damage_3',
        bgImage: '/assets/images/logo/camera_new.svg',
        isBGShow: true,
        loading: false
    },
    {
        id: 'image4',
        name: 'Damage',
        name_es: 'Damage',
        type: 'damage_4',
        bgImage: '/assets/images/logo/camera_new.svg',
        isBGShow: true,
        loading: false
    }
];
export class SmartphotoReopen {
    attributes;
    images;
    pages;
    format = {
        title: (page) => {
            const titleMap = {
                'information-form': this.attributes.useCase === 'Underwriting' ? 'information_form_underwriting' : 'information_form_claim',
                'side-pictures': 'side_pictures',
                'vehicle-side-pictures': 'side_pictures',
                'document-pictures': 'document_pictures',
                'damage-pictures': 'damage_pictures',
                'claim-damages': 'claim_damages',
                signature: 'signature'
            };
            return page.title ?? titleMap[page.name];
        },
        name: (page) => {
            const nameMap = {
                'information-form': 'data',
                'side-pictures': '360',
                'vehicle-side-pictures': '360',
                'document-pictures': 'images',
                'damage-pictures': 'images',
                'claim-damages': 'images',
                signature: 'images'
            };
            return nameMap[page.name];
        },
        fields: (page, smartphoto) => {
            let fields = page.selfadjustFields || [];
            if (page.name === 'information-form' && fields.length === 0) {
                const email = { dataType: 'text', fieldName: 'email', mandatory: true, labelContent: 'Email' };
                const textfield2 = {
                    dataType: 'text',
                    fieldName: 'textfield2',
                    mandatory: true,
                    labelContent: 'information_question'
                };
                const textfield3 = {
                    dataType: 'text',
                    fieldName: 'textfield3',
                    mandatory: true,
                    labelContent: 'information_description'
                };
                fields = [email, textfield2, textfield3];
                Object.defineProperties(page, {
                    fixedFields: {
                        get: () => [email, textfield2, textfield3].map(({ fix }) => Boolean(fix)),
                        enumerable: true,
                        configurable: true
                    }
                });
            }
            return fields.map((field) => {
                // eslint-disable-next-line no-param-reassign
                field.fix = false;
                return {
                    field: new SmartphotoField(field, smartphoto),
                    raw: field
                };
            });
        },
        images: {
            pictures: {
                document: (page) => {
                    const isCustom = Boolean(page.documentArray);
                    // eslint-disable-next-line no-param-reassign
                    page.documentArray = page.documentArray || defaultDocumentArray;
                    return page.documentArray.map((image) => {
                        if (!image.mode || image.mode === 'image') {
                            const { name: url } = this.imagesFromSmartphoto.find(({ type }) => type === image.type) ?? {};
                            const footer = isCustom ? image.name : image.type;
                            return {
                                url: url ?? '',
                                footer: footer,
                                raw: image
                            };
                        }
                        const url = this.documentsFromSmartphoto?.find((d) => d.type === image.id)?.name;
                        return {
                            url: url ?? '',
                            footer: image.id ?? '',
                            raw: image
                        };
                    });
                },
                damages: (page) => {
                    const isCustom = Boolean(page.damagePictures);
                    // eslint-disable-next-line no-param-reassign
                    page.damagePictures = page.damagePictures || defaultDamagePictures;
                    return page.damagePictures.map((image) => {
                        const { name: url } = this.imagesFromSmartphoto.find(({ type }) => type === image.type) ?? {};
                        const footer = isCustom ? image.name : image.type;
                        return {
                            url: url ?? '',
                            footer: footer,
                            raw: image
                        };
                    });
                }
            },
            claim: (page) => {
                // Get maximum images
                const max = page.maxImagesPerDamage || 6;
                // Get car parts reported
                const parts = Object.entries(this.carpart)
                    .filter(([, has]) => has)
                    .map(([part]) => part);
                const newImages = parts
                    .map((part, partIndex) => {
                    return new Array(max).fill(0).map((value, index) => {
                        const number = index + 1;
                        const image = this.imagesFromSmartphoto.find(({ type, vehiclePart, number: imgNumber }) => type === 'damage' && vehiclePart === part && imgNumber === number);
                        return {
                            url: image?.name || '',
                            footer: `${partIndex + 1}.${index + 1}`,
                            raw: {
                                id: `image${index + 1}`,
                                bgImage: '../../assets/images/logo/camera.svg',
                                fix: false,
                                isBGShow: true,
                                loading: false,
                                number: index + 1,
                                part,
                                type: 'damage'
                            }
                        };
                    });
                })
                    .flat(1);
                // eslint-disable-next-line no-param-reassign
                page.damagePictures = newImages.map(({ raw }) => raw);
                return newImages;
            },
            panoramic: (page) => {
                const images = this.images.panoramic;
                // eslint-disable-next-line no-param-reassign
                page.sidePictures = page.sidePictures || Constants.SIDE_PICTURES[this.vehicleType];
                return (page.sidePictures ?? []).map((image) => {
                    // eslint-disable-next-line no-param-reassign
                    image.fix = false;
                    const { url } = images.find(({ type }) => type === image.type) || { url: '' };
                    return {
                        url,
                        footer: image.type,
                        raw: image
                    };
                });
            },
            signature: () => {
                const signature = this.imagesFromSmartphoto.find(({ type }) => type === 'signature');
                if (!signature?.name) {
                    return [];
                }
                return [{ url: signature.name, footer: 'signature' }];
            }
        }
    };
    vehicleType;
    carpart;
    imagesFromSmartphoto;
    documentsFromSmartphoto;
    get = {
        pages: (smartphoto) => {
            const reopenable = [
                'information-form',
                'side-pictures',
                'vehicle-side-pictures',
                'document-pictures',
                'damage-pictures',
                'claim-damages',
                'signature'
            ];
            return this.pages
                .map((page) => ({
                title: this.format.title(page),
                type: this.format.name(page),
                images: this.getPageImages(page),
                fields: this.format.fields(page, smartphoto),
                page
            }))
                .filter(({ page }) => reopenable.includes(page.name));
        },
        reopenInfo: () => {
            const landing = this.pages.find(({ name }) => name === 'landing');
            const reopenedPages = this.pages.filter((page) => page.fixed === false && page.active === true);
            const final = this.pages.find(({ name }) => name === 'final');
            return [landing, ...reopenedPages, final];
        }
    };
    constructor(images, attributes, carpart, vehicleType, imagesFromSmartphoto, smartphotoInformation, documentsFromSmartphoto = []) {
        const { pages } = smartphotoInformation;
        this.pages = pages;
        this.attributes = attributes;
        this.carpart = carpart;
        this.vehicleType = vehicleType;
        this.images = images;
        this.imagesFromSmartphoto = imagesFromSmartphoto;
        this.documentsFromSmartphoto = documentsFromSmartphoto;
    }
    getPageImages(page) {
        let images = [];
        switch (page.name) {
            case 'document-pictures':
                images = this.format.images.pictures.document(page);
                break;
            case 'damage-pictures':
                images = this.format.images.pictures.damages(page);
                break;
            case 'claim-damages':
                images = this.format.images.claim(page);
                break;
            case 'side-pictures':
            case 'vehicle-side-pictures':
                images = this.format.images.panoramic(page);
                break;
            case 'signature':
                images = this.format.images.signature();
                break;
            default:
                break;
        }
        return images;
    }
}
